import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("ada_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("ada_email") || "");
  const [role, setRole] = useState(() => localStorage.getItem("ada_role") || "owner");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function verify() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await api.get("/auth/me");
        if (!cancelled) {
          setEmail(res.data.email);
          const r = res.data.role || "owner";
          setRole(r);
          localStorage.setItem("ada_role", r);
        }
      } catch {
        if (!cancelled) {
          setToken(null);
          localStorage.removeItem("ada_token");
          localStorage.removeItem("ada_email");
          localStorage.removeItem("ada_role");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    verify();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const login = async (em, password) => {
    const res = await api.post("/auth/login", { email: em, password });
    const t = res.data.access_token;
    const r = res.data.role || "owner";
    localStorage.setItem("ada_token", t);
    localStorage.setItem("ada_email", res.data.email);
    localStorage.setItem("ada_role", r);
    setToken(t);
    setEmail(res.data.email);
    setRole(r);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ada_token");
    localStorage.removeItem("ada_email");
    localStorage.removeItem("ada_role");
    setToken(null);
    setEmail("");
    setRole("owner");
  };

  return (
    <AuthCtx.Provider value={{ token, email, role, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
